import noDataFound from './../assets/images/no_data.svg'

export default () => (
    <div className="empty-content text-center">
        <div>
            <img src={noDataFound} height='150px' />
            <p>Nothing Found</p>
            <h6 className="fw-semi-bold mb-1">We couldn't find anything with this <br />criteria.</h6>
        </div>
    </div>)